module.exports = __webpack_public_path__ + "img/icon-point.52afae43.svg";